'use client';

import React from 'react';
import { motion } from 'motion/react';
import { 
  AnimatedSection,
  staggerContainer
} from '@/components/AnimatedComponents';
import * as LucideIcons from 'lucide-react';
import type { LucideProps } from 'lucide-react';

// Define the type for a single feature and for the props
type Feature = {
  title: string;
  description: string;
  icon: keyof typeof LucideIcons; // Accept icon name as a string
  color: string;
};

type TenantFeaturesProps = {
  features: readonly Feature[];
};

export default function ForTenantPageFeatures({ features }: TenantFeaturesProps) {
  return (
    <AnimatedSection
      variants={staggerContainer}
      className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20"
    >
      {features.map((feature, index) => {
        const IconComponent = LucideIcons[feature.icon] as React.FC<LucideProps>;
        return (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1, duration: 0.6 }}
            viewport={{ once: true }}
            className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300"
          >
            <div className="flex items-center mb-4">
              <div className="p-3 rounded-lg bg-blue-50 mr-4">
                {IconComponent && <IconComponent className="text-rentwise-blue-600" size={28} style={{ color: feature.color }} />}
              </div>
              <h3 className="text-xl font-semibold text-gray-900">{feature.title}</h3>
            </div>
            <p className="text-gray-600 leading-relaxed">{feature.description}</p>
          </motion.div>
        );
      })}
    </AnimatedSection>
  );
} 